export default __webpack_public_path__ + "static/pool-together-48574db8b301bfa6d9a196a7c850bb67.png";